module.exports = __webpack_public_path__ + "img/users.454ec353.svg";